import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as models from '../../models';
import { ZoneAllocateComponent } from 'app/components/zones/zone-allocate/zone-allocate.component';

// Thin chrome around <app-zone-allocate>, which owns the whole allocation
// surface (strain budget, zone list, floor-plan view) so the running totals stay
// pinned above every view.
@Component({
    selector: 'app-zone-assign',
    templateUrl: './zone-assign.component.html',
    styleUrls: ['./zone-assign.component.scss'],
    standalone: false
})
export class ZoneAssignComponent {

  @ViewChild(ZoneAllocateComponent) allocate: ZoneAllocateComponent;

  phase: models.HarvestPhase;

  constructor(
    private dialogRef: MatDialogRef<ZoneAssignComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.phase = data.phase;
    this.dialogRef.addPanelClass('zone-assign-redesign');
  }

  // Footer running total across every strain on the phase.
  get summary(): string {
    if (!this.allocate) return '';

    let strains = this.phase.strains || [];
    let placed = strains.reduce((sum, s) => sum + this.allocate.placedFor(s.strainId), 0);
    let target = strains.reduce((sum, s) => sum + (s.count || 0), 0);
    let zones = this.allocate.totalZonesAssigned;

    if (zones === 0) return 'No zones assigned yet';

    let zoneLabel = `${zones} ${zones === 1 ? 'zone' : 'zones'}`;
    if (target <= 0) return `${placed} plants placed across ${zoneLabel}`;
    return `${placed} of ${target} plants placed across ${zoneLabel}`;
  }

  savephaseZone() {
    this.allocate.commit();
    this.dialogRef.close(this.phase);
  }
}
